import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpParams, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AnaliseDescontoCampoPersonalizadoService {

  constructor(private http: HttpClient) {}

  consultarPorIdAnaliseDescontoCampoPersonalizado(id) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDescontoCampoPersonalizado/Buscar',
      { params: new HttpParams().set('id', id) });
  }
}
